//LOGIN
export const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAIL = "USER_LOGIN_FAIL";

//LOGOUT
export const USER_LOGOUT = "USER_LOGOUT";

//REGISTER
export const USER_REGISTER_REQUEST = "USER_REGISTER_REQUEST";
export const USER_REGISTER_SUCCESS = "USER_REGISTER_SUCCESS";
export const USER_REGISTER_FAIL = "USER_REGISTER_FAIL";

//USER DETAIL
export const USER_DETAIL_REQUEST = "USER_DETAIL_REQUEST";
export const USER_DETAIL_SUCCESS = "USER_DETAIL_SUCCESS";
export const USER_DETAIL_FAIL = "USER_DETAIL_FAIL";

//USER CHANGE PASSWORD
export const USER_CHANGE_PASSWORD_REQUEST = "USER_CHANGE_PASSWORD_REQUEST";
export const USER_CHANGE_PASSWORD_SUCCESS = "USER_CHANGE_PASSWORD_SUCCESS";
export const USER_CHANGE_PASSWORD_FAIL = "USER_CHANGE_PASSWORD_FAIL";

//USER CHANGE PASSWORD
export const USER_UPDATE_PROFILE_PICTURE_REQUEST =
  "USER_UPDATE_PROFILE_PICTURE_REQUEST";
export const USER_UPDATE_PROFILE_PICTURE_SUCCESS =
  "USER_UPDATE_PROFILE_PICTURE_SUCCESS";
export const USER_UPDATE_PROFILE_PICTURE_FAIL =
  "USER_UPDATE_PROFILE_PICTURE_FAIL";

//RESEND_EMAIL
export const USER_RESEND_EMAIL_REQUEST = "USER_RESEND_EMAIL_REQUEST";
export const USER_RESEND_EMAIL_SUCCESS = "USER_RESEND_EMAIL_SUCCESS";
export const USER_RESEND_EMAIL_FAIL = "USER_CHANGE_PASSWORD_FAIL";

//REGISTER_WITH_PASSWORD
export const USER_REGISTER_WITH_PASSWORD_REQUEST =
  "USER_REGISTER_WITH_PASSWORD_REQUEST";
export const USER_REGISTER_WITH_PASSWORD_SUCCESS =
  "USER_REGISTER_WITH_PASSWORD_SUCCESS";
export const USER_REGISTER_WITH_PASSWORD_FAIL =
  "USER_REGISTER_WITH_PASSWORD_FAIL";
